var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combineReader } from '@devexperts/utils/dist/adt/reader.utils';
import cn from 'classnames';
import * as React from 'react';
import { Component } from 'react';
import Draggable from 'react-draggable';
import Dropzone from 'react-dropzone';
import { Button } from 'reactstrap';
import { AttachmentPreview } from './AttachmentPreview';
import { AuthorNameInput } from './AuthorNameInput';
import { CommentNumber } from './CommentNumber';
import { LoadingButton } from './LoadingButton';
import style from './Note.module.scss';
import NoteTextArea from './NoteTextArea';
import { TabIndexBlocker } from './TabIndexBlocker';
var acceptedFiles = ['image/png', 'image/jpeg', 'image/bmp', 'image/gif'];
var authorNameTheme = {
    container: style.authorField,
    input: style.authorInput,
};
export default combineReader(AuthorNameInput, function (AuthorNameInput) {
    return /** @class */ (function (_super) {
        __extends(Note, _super);
        function Note() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                note: {
                    note: '',
                    attachments: [],
                    mentions: [],
                },
                mentions: [],
                isDragging: false,
            };
            // tslint:disable-next-line: variable-name
            _this.handleTextAreaChange = function (value) {
                _this.setState({
                    note: __assign(__assign({}, _this.state.note), { note: value.note }),
                    mentions: value.mentions,
                });
            };
            _this.handleSave = function () {
                return _this.props.onSave &&
                    _this.props.onSave(__assign(__assign({}, _this.state.note), { mentions: _this.state.mentions }));
            };
            _this.handlePaste = function (e) {
                if (e.clipboardData.files.length) {
                    _this.handleAttach([e.clipboardData.files[0]]);
                }
            };
            _this.handleAttach = function (files) {
                _this.setState({
                    note: __assign(__assign({}, _this.state.note), { attachments: __spreadArray(__spreadArray([], _this.state.note.attachments, true), files, true) }),
                });
            };
            _this.renderAttachment = function (attachment, index) {
                return (React.createElement(AttachmentPreview, { key: index, file: attachment, className: style.attachmentPreview, onRemove: function () { return _this.handleDeleteAttachment(attachment); } }));
            };
            _this.handleDeleteAttachment = function (attachment) {
                _this.setState({
                    note: __assign(__assign({}, _this.state.note), { attachments: _this.state.note.attachments.filter(function (a) { return a !== attachment; }) }),
                });
            };
            _this.handleKeyDown = function (e) {
                var _a = _this.props, onCancel = _a.onCancel, onSave = _a.onSave;
                switch (e.code) {
                    case 'Escape':
                        if (onCancel) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            onCancel();
                        }
                        break;
                    case 'Enter':
                        if (e.ctrlKey && onSave && !_this.isPending()) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            _this.handleSave();
                        }
                        break;
                }
            };
            _this.isPending = function () { var _a; return !!((_a = _this.props.saveResult) === null || _a === void 0 ? void 0 : _a.isPending()); };
            return _this;
        }
        Note.prototype.componentDidMount = function () {
            document.body.addEventListener('keydown', this.handleKeyDown);
        };
        Note.prototype.componentWillUnmount = function () {
            document.body.removeEventListener('keydown', this.handleKeyDown);
        };
        Note.prototype.render = function () {
            var _this = this;
            var _a = this.props, pos = _a.pos, onCancel = _a.onCancel, nameField = _a.nameField;
            var note = this.state.note;
            var attachments = note.attachments;
            var left = pos.screenX;
            var top = pos.screenY;
            var formStyle = {};
            var isDropUp = pos && pos.screenY + 300 > window.innerHeight;
            if (isDropUp) {
                formStyle.bottom = window.innerHeight - pos.screenY + 70;
            }
            else {
                formStyle.top = pos.screenY;
            }
            var isMirror = pos && pos.screenX < 340 - 40;
            if (isMirror) {
                formStyle.left = Math.max(-43, pos.screenX - 76);
            }
            else {
                formStyle.left = Math.min(window.innerWidth - 340 - 40, pos.screenX - 340);
            }
            var isPending = this.isPending();
            // TODO: reposition the note when rect changes
            return (React.createElement(TabIndexBlocker, null,
                React.createElement(Draggable, { onStart: function () { return _this.setState({ isDragging: true }); }, onStop: function (_, data) {
                        _this.setState({ isDragging: false });
                        _this.props.onPositionChange(data.lastX, data.lastY);
                    }, bounds: this.props.rect, position: { x: left, y: top } },
                    React.createElement("div", { className: style.draggableNumber },
                        React.createElement(CommentNumber, { number: this.props.number, isInteractive: true, isPositioned: true, isDragged: this.state.isDragging }))),
                React.createElement("div", { className: cn(style.commentForm, isMirror && style.commentForm_mirror, isDropUp && style.commentForm_dropUp, this.state.isDragging && style.commentForm_hidden), style: formStyle },
                    React.createElement("button", { className: cn('close', style.close), type: "button", onClick: onCancel },
                        React.createElement("i", { className: cn('material-icons', style.closeIcon) }, "close")),
                    React.createElement("div", { className: cn(style.commentForm__body, !!nameField && style.commentForm__body_hasAuthorName) },
                        nameField && React.createElement(AuthorNameInput, __assign({}, nameField, { theme: authorNameTheme })),
                        React.createElement("div", { onPaste: this.handlePaste },
                            React.createElement(NoteTextArea, { value: note, teamMembers: this.props.teamMembers, onChange: this.handleTextAreaChange, isPending: isPending }),
                            React.createElement("div", { className: style.attachments }, attachments.map(this.renderAttachment)))),
                    React.createElement("div", { className: style.commentForm__footer },
                        React.createElement("div", { className: style.commentForm__hotkeys },
                            React.createElement("strong", null, "Ctrl + Return"),
                            " to send note"),
                        React.createElement(Dropzone, { noClick: true, noKeyboard: true, disabled: isPending, onDropAccepted: this.handleAttach, multiple: true, accept: acceptedFiles }, function (_a) {
                            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, open = _a.open, isDragActive = _a.isDragActive;
                            return (React.createElement("div", __assign({}, getRootProps({
                                className: cn(style.commentForm__dropZone, isDragActive && style.commentForm__dropZone_active),
                            })),
                                React.createElement("input", __assign({}, getInputProps())),
                                React.createElement(Button, { color: "flat", className: cn('btn-icon', style.commentForm__attachButton), onClick: open, disabled: isPending },
                                    React.createElement("i", { className: "material-icons" }, "attachment"))));
                        }),
                        React.createElement(LoadingButton, { color: "primary", className: style.commentForm__saveButton, pending: isPending, onClick: this.handleSave }, isPending ? 'Posting...' : 'Send note')))));
        };
        return Note;
    }(Component));
});
//# sourceMappingURL=Note.js.map